/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function DataIngestion(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 20 20" fill="none" height={size} width={size} {...other}>
      <path
        d="M15 17.482C13.57 18.44 11.851 19 10 19C9.088 19 8.209 18.862 7.38 18.61M10 14V6M10 14L13 11M10 14L7 11M4.349 17C3.068 15.965 2.084 14.583 1.523 13M17.463 15C18.427 13.569 19 11.855 19 10C19 5.029 14.971 1 10 1M3.16 4.16C3.621 3.62 4.146 3.139 4.722 2.722L3.16 4.16ZM1.523 7C1.19 7.94 1 8.946 1 10L1.523 7Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DataIngestion.defaultProps = {
  color: "current",
  size: 24,
};

DataIngestion.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
